import { render, staticRenderFns } from "./Lunch.vue?vue&type=template&id=3a69d036&"
import script from "./Lunch.vue?vue&type=script&lang=js&"
export * from "./Lunch.vue?vue&type=script&lang=js&"
import style0 from "./Lunch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports